import { ROUTES } from "./routes";

export const ACCOUNT_NAV_ITEMS = [
  {
    key: "profile",
    label: "Cá nhân",
    path: ROUTES.ACCOUNT_PROFILE,
  },
  {
    key: "addresses",
    label: "Sổ địa chỉ",
    path: ROUTES.ACCOUNT_ADDRESSES,
  },
  {
    key: "orders",
    label: "Đơn hàng",
    path: ROUTES.ACCOUNT_ORDERS,
  },
  {
    key: "security",
    label: "Bảo mật",
    path: ROUTES.ACCOUNT_SECURITY,
  },
] as const;
